"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDeleteDialog = exports.EntityDeleteDialogDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var dialog_1 = require("../elements/dialog");
var html_1 = require("../elements/html");
var icon_button_1 = require("../elements/icon-button");
var sprintf_js_1 = require("sprintf-js");
var loader_1 = require("../elements/loader");
exports.EntityDeleteDialogDefaultProps = {};
// -------- Styles -------->
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
var EntityDeleteDialog = function (props) {
  var className = props.className,
    entity = props.entity,
    onComplete = props.onComplete,
    onCancel = props.onCancel,
    mutation = props.mutation;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var _a = __read((0, react_1.useState)(null), 2),
    deleting = _a[0],
    setDeleting = _a[1];
  var onConfirm = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(mutation && entity.id)) return [3 /*break*/, 2];
            setDeleting(true);
            return [4 /*yield*/, mutation({
              variables: {
                id: entity.id
              }
            })];
          case 1:
            result = _a.sent();
            onComplete(result);
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  var icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var button = react_1.default.createElement(icon_button_1.IconButton, {
    onClick: onConfirm,
    icon: react_1.default.createElement(icons.TickCircle, null)
  }, t('Confirm'));
  var message = (0, sprintf_js_1.sprintf)(definition.removeMessage, definition.label);
  var title = (0, sprintf_js_1.sprintf)(t('Delete %s'), definition.label);
  return react_1.default.createElement(My.Dialog, {
    title: title,
    showCancelButton: !deleting,
    onCancel: onCancel,
    icon: icons.MinusCircle,
    button: !deleting && button
  }, deleting ? react_1.default.createElement(My.Loader, {
    spinnerSize: 24
  }) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(html_1.HTML, {
    text: message
  })));
};
exports.EntityDeleteDialog = EntityDeleteDialog;
exports.EntityDeleteDialog.defaultProps = exports.EntityDeleteDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;